export const SELECT_REPORTING_TAB = 'REPORTING_SELECT_REPORTING_TAB';

export const selectReportingTab = selectedTab => ({
  type: SELECT_REPORTING_TAB,
  selectedTab,
});
